import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { ProgressCircular } from '@mint-lib/tw-components/patterns';
import { cn } from '@mint-lib/tw-utils';

const Loader = () => {
  const { t } = useTranslation('@myn/integrations_v2');

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <ProgressCircular />
      <h5 className={cn('mt-2', typographyVariants({ variant: 'h5' }))}>
        {t('Loading...')}
      </h5>
    </div>
  );
};

export default Loader;
